export default __webpack_public_path__ + "components/page-header/static/mountain-forecast__logo--clear-2dd478a080949ad3c77d410e33f5e0a6.png";